export default __webpack_public_path__ + "static/media/Pright.b6764860.jpeg";